import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@enviroment/environment';
import {DefaultResponse} from '@core/models/Http/DefaultResponse';
import {UserDetails} from "@core/models/UserDetails";
import {DoctorDetails} from "@core/models/DoctorDetails";
import {PatientDetails} from "@core/models/PatientDetails";
import {MedicByIdUser} from "@core/models/MedicByIdUser";
import {Branch} from "@core/models/Branch";
import {GEMP} from "@core/models/GEMP";

@Injectable({
  providedIn: 'root',
})
export class CreateEditService {
  constructor(private http: HttpClient) {
  }

  getUserById(idGEMP: string | null) {
    let params = new HttpParams();
    if (idGEMP) {
      params = params.set('IdGEMP', idGEMP);
    }

    return this.http.get<DefaultResponse<UserDetails[]>>(
      `${environment.backend_url}Usuarios`,
      { params }
    );
  }

  getUserByUsr(usr: string) {
    const params = new HttpParams().set('Usr', usr);

    return this.http.get<DefaultResponse<UserDetails>>(
      `${environment.backend_url}Usuarios`,
      { params }
    );
  }

  getUsersBySucursal(idSucursal: string) {
    const params = new HttpParams().set('IdSucursal', idSucursal);

    return this.http.get<DefaultResponse<UserDetails[]>>(
      `${environment.backend_url}Usuarios`,
      { params }
    );
  }

  getpatientByIdUser(idUser: string) {
    const params = new HttpParams().set('IdUsuario', idUser);

    return this.http.get<DefaultResponse<PatientDetails>>(
      `${environment.backend_url}Pacientes`,
      { params }
    );
  }

  getPacienteByIdUsuario() {
    return this.http.get<DefaultResponse<PatientDetails>>(
      `${environment.backend_url}Pacientes/ByIdUsuario/`
    );
  }

  getPacienteByUsuarioId(idUsuario: string) {
    return this.http.get<DefaultResponse<PatientDetails>>(
      `${environment.backend_url}Pacientes/ByIdUsuario/${idUsuario}`
    );
  }


  getTutorByPatientId(idPaciente: string) {
    return this.http.get<DefaultResponse<any>>(
      `${environment.backend_url}Tutores/PorPaciente/${idPaciente}`
    );
  }

  getBranchByIdBranch(idBranch: string) {
    const params = new HttpParams().set('IdSucursal', idBranch);

    return this.http.get<DefaultResponse<Branch>>(
      `${environment.backend_url}Sucursales/GetSucursales`,
      { params }
    );
  }


  getGempbyIdGemp(idGemp: string | null) {
    return this.http.get<DefaultResponse<GEMP>>(
      `${environment.backend_url}CatGrupoEmpresarial/GetGrupoEmpresarial`,
      {
        params: { id: idGemp ?? '' }
      }
    );
  }
}
